define('taoQtiItem/qtiCreator/widgets/interactions/customInteraction/states/states',[
    'taoQtiItem/qtiCreator/widgets/states/factory',
    'taoQtiItem/qtiCreator/widgets/interactions/states/states',
    'taoQtiItem/qtiCreator/widgets/interactions/customInteraction/states/Question',
    'taoQtiItem/qtiCreator/widgets/interactions/customInteraction/states/Sleep'
], function(factory, states){
    return factory.createBundle(states, arguments);
});
